export default "__VITE_ASSET__Cpjp4qU___"